module.exports = __webpack_public_path__ + "img/icon-mew-connect.b60cbe80.svg";